import React, { useState, useEffect } from "react";
import DetailedItem from "Views/ActivityList/DetailedItem";
import ActivityFormCategory from "./Fields/Category";
import ActivityFormTeam from "./Fields/Team";
import EmailUserSelector from '../../Components/EmailUserSelector/EmailUserSelector';
import {
  VegaFlex,
  VegaForm,
  VegaButton,
  VegaCheckbox,
  VegaAccordion,
  VegaInput,
  VegaFont,
} from "@heartlandone/vega-react";
const FIFTH_STEP = 4;

function StepFive({
  currentStep,
  onPreviousClick = () => {},
  onNextClick = () => {},
  form = {},
  isEdit = false,
}) {
  const _isShow = () => currentStep === FIFTH_STEP;
  const [maxDiabled, setMaxDiabled] = useState(form?.registerSetting?.isAllowInviteGuests ? false : true);
  const [maxValue, setMaxValue] = useState(form?.registerSetting?.maxInvitedGuests || 0);
  const [currentCategory, setCurrentCategory] = useState();
  const [canGoNext, setCanGoNext] = useState(false);
  const [receiverIds, setReceiverIds] = useState([]);
  const [options, setOptions] = useState([]);
  const [isTeamValid, setIsTeamValid] = useState(true);
  const onTeamValid = (valid) => {
    setIsTeamValid(valid);
  }
  const selectedOptions = options.filter(item =>
    receiverIds.includes(item.key)
  );

  const groupIds = selectedOptions
    .filter(item => item.type === 'group')
    .map(item => item.key);

  const recipientEmailAddresses = selectedOptions
    .filter(item => item.type === 'user')
    .map(item => item.email);
  
  
  useEffect(() => {
    if (maxDiabled) {
      setMaxValue("0");
    }
  }, [maxDiabled]);

  useEffect(() => {
    let publishValid = currentCategory !== 'Personal' ?
      (groupIds.length > 0 || recipientEmailAddresses.length > 0) : true;
    if (!maxDiabled) {
      publishValid = publishValid && Number(maxValue) > 0;
    }
    if(isEdit && currentCategory !== 'Personal' ) {
      publishValid = receiverIds.length > 0;
    }
    setCanGoNext(publishValid);
  }, [currentCategory, groupIds, recipientEmailAddresses, maxDiabled, maxValue, receiverIds, isEdit]);
  
  return (
    <div className={`m-t-32${_isShow() ? "" : " display-none"}`}>
      <h2 style={{ marginBottom: 20 }} className="form-step-title ">
        Review & Publish
      </h2>
      <div
        style={{
          backgroundColor: "#f2f2f2",
          padding: "32px",
          borderRadius: "12px",
          minWidth: "864px",
        }}
      >
        <VegaFlex
          justifyContent="flex-start"
          alignItems="flex-start"
          gap="size-32"
        >
          {/* Left Section */}
          <div style={{ width: '52%' }}>
            <DetailedItem form={form} isEdit={isEdit}/>
          </div>

          {/* Right Section */}
          <VegaFlex gap={"size-24"} direction={"col"} flex={1}>
            <VegaFont variant='font-field-value-em' color="text-primary">Activity Category</VegaFont>
            <ActivityFormCategory onChange={setCurrentCategory} isEdit={isEdit}/>
            {(currentCategory && currentCategory !== 'Personal') && <EmailUserSelector
              isOpen={currentCategory !== "Personal"}
              value={receiverIds}
              onChange={setReceiverIds}
              onOptionsChange={setOptions}
              label="Email To"
              placeholder=""
            />}
            <VegaAccordion accordionTitle="Guest Invitation">
              <VegaForm
                alignItems={"end"}
                gap="size-16"
                data-vega-form="registerSetting"
                slot="content"
              >
                <VegaCheckbox
                  className="no-padding-checkbox"
                  label="Allow external invitation."
                  disabled={isEdit}
                data-vega-form={"isAllowInviteGuests"}
                  onVegaChange={(e) => {
                    if (!e.detail) setMaxValue("0");
                    setMaxDiabled(!e.detail);
                  }}
                >
                  Allow external invitation.
                </VegaCheckbox>
                <VegaFlex
                  direction="row"
                  className="m-t-32"
                  gap="size-16"
                  alignItems={"center"}
                >
                  <VegaInput
                    type="number"
                    size="small"
                    style={{
                      width: 80,
                    }}
                    value={maxValue}
                  data-vega-form={"maxInvitedGuests"}
                    disabled={maxDiabled || isEdit}
                    maxLength={9}
                    onVegaChange={(e) => {
                      setMaxValue(e.detail);
                    }}
                  />
                  <VegaFont>
                    Maximum guest allowed.
                  </VegaFont>
                </VegaFlex>
              </VegaForm>
            </VegaAccordion>
            {currentCategory === "Company" && <VegaAccordion
              accordionTitle="Team Recruitment"
              style={{ display: currentCategory === "Company" ? "block" : "none" }}
            >
              <div slot="content">
                <ActivityFormTeam isEdit={isEdit} isShow={_isShow} onValid={onTeamValid} activityAllowRoles={form.activityAllowRoles} />
              </div>
            </VegaAccordion>}
          </VegaFlex>
        </VegaFlex>

      </div>
      <VegaFlex
        justifyContent="space-between"
        className="m-t-40 p-t-20 p-b-48 border-none"
      >
        <VegaButton
          variant="secondary"
          label="Previous"
          onVegaClick={() => onPreviousClick('Review & Publish')}
        />

        <VegaButton
          label="Publish"
          disabled={!canGoNext || !isTeamValid}
          onVegaClick={() =>
            onNextClick({
            })
          }
        />
      </VegaFlex>
    </div>
  );
}

export default StepFive;
